export const getLocaleFromUrl = (): string => {
  if (window.location.pathname.startsWith('/it')) return 'it';
  else return 'en';
};
